import { render, staticRenderFns } from "./PlanejamentoAcaoFormPrevia.vue?vue&type=template&id=e5752190&"
import script from "./PlanejamentoAcaoFormPrevia.vue?vue&type=script&lang=js&"
export * from "./PlanejamentoAcaoFormPrevia.vue?vue&type=script&lang=js&"
import style0 from "./PlanejamentoAcaoFormPrevia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports